<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-row gap-2">
      <div
        class="flex-1 bg-untitled-gray-100 rounded-md h-32 relative flex flex-col justify-center items-center gap-3 animate-pulse"
      >

      </div>
      <div
        class="flex-1 bg-untitled-gray-100 rounded-md h-32 relative flex flex-col justify-center items-center gap-3 animate-pulse"
      >

      </div>
      <div
        class="flex-1 bg-untitled-gray-100 rounded-md h-32 relative flex flex-col justify-center items-center gap-3 animate-pulse"
      >

      </div>
    </div>
  </div>
</template>

<script setup>
</script>

<style lang="scss" scoped></style>
